import React, { useState } from 'react';
import { Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrandImage } from 'API';
import { SxProps } from '@mui/system';

const useStyles: any = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1, 0, 2, 0),
        [theme.breakpoints.down('md')]: {
          paddingBottom: theme.spacing(1.5),
        },
      },
      title: {
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          paddingBottom: theme.spacing(0.5),
        },
      },
      cta: {
        paddingTop: theme.spacing(2),
        textAlign: 'center',
      },
      brandLogo: {
        minHeight: 127,
        [theme.breakpoints.down('md')]: {
          minHeight: 76,
        },
      },
      brandLogoImg: {
        maxWidth: '100%',
        height: 'auto',
      },
    }),
  { name: 'BrandGrid' },
);

const BrandGrid: React.FC<{
  items: BrandImage[];
  title?: string;
  buttonTitle?: string;
  sx?: SxProps<Theme>;
  addImageTitle?: boolean;
}> = ({ items, title, buttonTitle = 'retailers', sx, addImageTitle = false }) => {
  const styles = useStyles();
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const defaultDesktopItems = 6;
  const defaultMobileItems = 6;
  const displayedItems = expanded ? items.length : isDesktop ? defaultDesktopItems : defaultMobileItems;

  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  const showCTA = (isDesktop && items.length > defaultDesktopItems) || (!isDesktop && items.length > defaultMobileItems);

  return (
    <Box sx={{ flexGrow: 1, ...sx }} className={styles.root}>
      {title && (
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>
      )}
      <Grid container spacing={{ xs: 2, sm: 4 }}>
        {items.slice(0, displayedItems).map((item, idx) => {
          const { brand } = item;
          // @ts-ignore
          const svgImage = `data:image/svg+xml;base64,${btoa(item.image || item.brand_cgo_logo)}`;

          return (
            <Grid key={'brand-' + brand + '-' + idx} item xs={4} sm={2} className={styles.brandLogo} display="flex" justifyContent="center" alignItems="center" sx={{ p: { xs: 2, sm: 4 } }}>
              <img src={svgImage} className={styles.brandLogoImg} alt={brand || ''} title={(addImageTitle && brand) || ''} />
            </Grid>
          );
        })}
      </Grid>
      {showCTA && (
        <div className={styles.cta}>
          <Button size="large" color="primary" variant="outlined" endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />} onClick={toggleExpand}>
            {`View ${expanded ? 'less' : 'all'} ${buttonTitle}`}
          </Button>
        </div>
      )}
    </Box>
  );
};

export default BrandGrid;
